<!-- <div class="container h-100 m-0 p-0" >
    <div class="row h-100 m-0 p-0">
        <div class="col-md-6 p-0 m-0">
            <div class="login-image" >
                <div class="items" >
                    <span class="item" >Notice | </span>
                    <span class="item" >General T&C | </span>
                    <span class="item" >Privacy Policy</span>
                </div>
                <img height="100%" width="100%" src="./../../../assets/login-image.jpg" alt="login" srcset="">
            </div>
        </div>
        <div class="col-md-6 p-0 m-0">

        </div>
    </div>
   
</div> -->

<div class="container loginContain h-100">
  <div class="row h-100 p-0 m-0">
    <div class="col-md-6 h-100 p-0">
      <div class="items poweredBy position-absolute">Powered By TCS Platform Solutions | <span
          (click)="showBrowserCompatablity()"> Browser Compatibility |</span>
        <span (click)="showNotice()"> Cookie Policy | </span>
        <span (click)="showGeneralTnC()"> Privacy Policy| </span>
        <span (click)="showPrivacyPolicy()">Security Policy </span>
      </div>
      <img src="./assets/login-image.jpg" class="homeImage" alt="Home">
    </div>
    <div class="col-md-6 h-100 p-0">
      <div class="col-md-12 h-100">
        <div class="row cape-loginform-container m-auto h-100">
          <!-- <div class="col-md-3"></div> -->
          <div class="col-md-12 cape-logo">
            <img src="./assets/tcs-em-logo.png">
          </div>
          <div class="pt-3">
            <form [formGroup]="loginForm">
              <div class="form-group py-2">
                <div class="">
                  <input type="text" formControlName="username" autocomplete="off" class="form-control"
                    placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                </div>
              </div>
              <div class="form-group py-1 pb-2">
                <div class="">
                  <input type="password" formControlName="password" autocomplete="off" class="form-control"
                    placeholder="Password" aria-label="Username" aria-describedby="basic-addon1">
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-8">
                  <div class="ml-auto cape-forgot-password-link">
                    <a id="forgot">Forgot Password?</a>
                  </div>
                </div>
              </div> -->

              <button class="btn btn-block text-center my-3 cape-login-btn" (click)="login()"
                [disabled]="loginForm.invalid">Log in</button>
            </form>
            <div class="text-centre text-muted copyRight font-12p">
              &copy; Tata Consultancy Services Limited. All Rights Reserved.
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
